import React from 'react';
import style from './style';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import withBoundary from 'component/ErrorBoundary/withBoundary';
const ImageView = (props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between'
      }}>
      <Box
        sx={props.active ? style.activeCard : style.card}
        onClick={props.onClick}>
        <Box sx={style.timeView}>{props.time}</Box>
        <img src={props.image} />
        {props.active ? (
          <Box sx={style.backgroundView}>
            {props.name} <img src={props.micOn} /> <img src={props.volumeOn} />
          </Box>
        ) : (
          <Box sx={style.backgroundView}>
            {props.name} <img src={props.mic} /> <img src={props.volume} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
ImageView.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  time: PropTypes.string,
  mic: PropTypes.symbol,
  micOn: PropTypes.symbol,
  volumeOn: PropTypes.symbol,
  volume: PropTypes.symbol,
  onClick: PropTypes.func,
  active: PropTypes.bool
};
export default React.memo(withBoundary(ImageView));
